export default [
  {
    name: 'User',
    to: '#',
    header: true,
    permissionsAny: ["kl_account_add", "kl_account_edit", "kl_account_approve"]
  },
  {
    name: 'Create User',
    icon: 'fal fa-user-plus fa-fw',
    to: '/user/add',
    permission: 'kl_account_add'
  },
  {
    name: 'Manage User',
    icon: 'fal fa-users fa-fw',
    to: '/user/list',
    permission: 'kl_account_edit'
  },
  {
    name: 'Contributor Request',
    icon: 'fal fa-file-user fa-fw',
    to: '/user/contributor/request',
    permission: 'kl_account_approve'
  },
  {
    name: 'Article',
    to: '#',
    header: true,
    permissionsAny: ["kl_article_add", "kl_article_edit", "kl_article_edit_full"]
  },
  {
    name: 'Create Article',
    icon: 'fal fa-plus-circle fa-fw',
    to: '/article/create',
    permission: 'kl_article_add'
  },
  {
    name: 'Manage Article',
    icon: 'fal fa-newspaper fa-fw',
    to: '/article/list',
    permission: 'kl_article_edit'
  },
  {
    name: 'Premium Article',
    icon: 'fal fa-crown fa-fw',
    to: '/article/premium',
    permission: 'kl_article_edit'
  },  
  {
    name: 'Hot Article',
    icon: 'fal fa-fire-alt fa-fw',
    to: '/article/hot',
    permission: 'kl_article_edit_full'
  },
  {
    name: 'PR Article',
    icon: 'fal fa-usd-circle fa-fw',
    to: '/article/pr',
    permission: 'kl_sale_view'
  },
  {
    name: 'Fashion',
    to: '#',
    header: true,
    permissionsAny: ["fashion_model_list", "fashion_photo_list"]
  },
  {
    name: 'Model',
    icon: 'fal fa-portrait fa-fw',
    to: '/fashion/model/list',
    permission: "fashion_model_list"
  },
  {
    name: 'Daily Photo',
    icon: 'fal fa-image fa-fw',
    to: '/fashion/photo/list',
    permission: "fashion_photo_list"
  },
  {
    name: 'Customer',
    to: '#',
    header: true,
    permissionsAny: ['kl_customer_add', 'kl_customer_edit']
  },
  {
    name: 'Create Customer',
    icon: 'fal fa-user-plus fa-fw',
    to: '/customer/add',
    permission: 'kl_customer_add'
  },
  {
    name: 'Manage Customer',
    icon: 'fal fa-users fa-fw',
    to: '/customer/list',
    permissionsMust: ['kl_customer_add', 'kl_customer_edit', 'kl_customer_list']
  },
  {
    name: 'Advertisement',
    to: '#',
    header: true,
    permission: 'super_admin'
  },
  {
    name: 'Create Ads Campaign',
    icon: 'fal fa-plus-circle fa-fw',
    to: '/ads/campaign/add',
    permission: 'super_admin'
  },
  {
    name: 'Ads Campaign',
    icon: 'fal fa-ad fa-fw',
    to: '/ads/campaign/list?status=ACTIVE',
    permission: 'super_admin'
  },
  {
    name: 'Analytics',
    to: '#',
    header: true,
    permissionsAny: ["kl_analytic", "kl_article_list_all"]
  },
  {
    name: 'My Analytics',
    icon: 'fal fa-analytics fa-fw',
    to: '/user/analytic/pageview',
    permission: 'kl_analytic'
  },
  {
    name: 'User Analytics',
    icon: 'fal fa-user-chart fa-fw',
    to: '/user/analytics',
    permission: 'kl_article_list_all'
  },
  {
    name: 'Disbursement',
    to: '#',
    header: true,
    permissionsAny: ["kl_disbursement_request", "kl_disbursement_list"]
  },
  {
    name: 'Request Disbursement',
    icon: 'fal fa-hand-holding-usd fa-fw',
    to: '/disbursement/request',
    permission: 'kl_disbursement_request'
  },
  {
    name: 'Manage Disbursement',
    icon: 'fal fa-file-invoice-dollar fa-fw',
    to: '/disbursement/list',
    permission: 'kl_disbursement_list'
  },
  {
    name: 'Report',
    to: '#',
    header: true,
    permissionsAny: ["kl_article_publish", "kl_article_add", "kl_article_list_all"]
  },
  {
    name: 'Report Article',
    icon: 'fal fa-newspaper fa-fw',
    to: '#',
    subs: [
      {
        name: 'Top Article By Hour',
        icon: 'fal fa-stopwatch fa-fw',
        to: '/report/article/topbyhour',
        permission: "kl_article_publish"
      },
      {
        name: 'Total Article',
        icon: 'fal fa-chart-line fa-fw',
        to: '/report/article/total',
        permission: 'kl_article_add'
      },
      {
        name: 'Total Article By Category',
        icon: 'fal fa-file-chart-line fa-fw',
        to: '/report/article/totalbycategory',
        permission: 'kl_article_publish'
      },
      {
        name: 'Total Article By Writer',
        icon: 'fal fa-user-chart fa-fw',
        to: '/report/article/totalbywriter',
        permission: 'kl_article_list_all'
      }
    ],
    permission: 'kl_article_add'
  },
  {
    name: 'Reward Panel',
    icon: 'fal fa-award fa-fw',
    to: '#',
    permission: "kl_article_add",
    subs: [
      {
        name: 'Top Article',
        icon: 'fal fa-trophy fa-fw',
        to: '/report/reward/article/top',
        permission: "kl_article_add"
      },
      {
        name: 'Top Writer',
        icon: 'fal fa-user-crown fa-fw',
        to: '/report/reward/user/topwriter',
        permission: "kl_view_reward"
      },
      {
        name: 'Top Sale Writer',
        icon: 'fal fa-usd-circle fa-fw',
        to: '/report/reward/user/topsalewriter',
        permission: "kl_article_edit_full"
      }
    ]
  },
  {
    name: 'Editor Performance',
    icon: 'fal fa-project-diagram fa-fw',
    to: '/report/editorperformance',
    permission: 'kl_article_list_all'
  },
  {
    name: 'Overall',
    icon: 'fal fa-chart-network fa-fw',
    to: '/report/overall',
    permission: 'kl_article_list_all'
  }
];
